var map = {
	"./actor-chaplin-comedy-svgrepo-com.svg": 7985,
	"./addicted-draw-love-svgrepo-com.svg": 5768,
	"./afro-avatar-male-2-svgrepo-com.svg": 7121,
	"./afro-avatar-male-svgrepo-com.svg": 8808,
	"./afro-boy-child-svgrepo-com.svg": 7812,
	"./afro-female-person-svgrepo-com.svg": 4177,
	"./alien-avatar-space-svgrepo-com.svg": 6952,
	"./animal-avatar-bear-svgrepo-com.svg": 6025,
	"./animal-avatar-mutton-svgrepo-com.svg": 5902,
	"./anime-away-face-svgrepo-com.svg": 4137,
	"./apple-avatar-illness-svgrepo-com.svg": 4737,
	"./artist-avatar-marilyn-svgrepo-com.svg": 2986,
	"./avatar-avocado-food-svgrepo-com.svg": 814,
	"./avatar-bad-breaking-svgrepo-com.svg": 3195,
	"./avatar-batman-comics-svgrepo-com.svg": 2514,
	"./avatar-boy-kid-svgrepo-com.svg": 2769,
	"./avatar-boy-male-svgrepo-com.svg": 8358,
	"./avatar-bug-insect-svgrepo-com.svg": 889,
	"./avatar-cacti-cactus-svgrepo-com.svg": 368,
	"./avatar-child-girl-svgrepo-com.svg": 6071,
	"./avatar-cloud-crying-svgrepo-com.svg": 7490,
	"./avatar-coffee-cup-svgrepo-com.svg": 5245,
	"./avatar-dead-monster-svgrepo-com.svg": 3389,
	"./avatar-einstein-professor-svgrepo-com.svg": 4461,
	"./avatar-elderly-grandma-svgrepo-com.svg": 5662,
	"./avatar-female-girl-svgrepo-com.svg": 4563,
	"./avatar-female-portrait-2-svgrepo-com.svg": 465,
	"./avatar-female-portrait-svgrepo-com.svg": 664,
	"./avatar-geisha-japanese-svgrepo-com.svg": 2139,
	"./avatar-hindi-indian-svgrepo-com.svg": 3986,
	"./avatar-joker-squad-svgrepo-com.svg": 1624,
	"./avatar-lazybones-sloth-svgrepo-com.svg": 8364,
	"./avatar-male-man-svgrepo-com.svg": 370,
	"./avatar-male-ozzy-svgrepo-com.svg": 8408,
	"./avatar-male-president-svgrepo-com.svg": 9570,
	"./avatar-man-muslim-svgrepo-com.svg": 5050,
	"./avatar-man-person-svgrepo-com.svg": 2508,
	"./avatar-muslim-paranja-svgrepo-com.svg": 791,
	"./avatar-nun-sister-svgrepo-com.svg": 4742,
	"./avatar-person-pilot-svgrepo-com.svg": 6444,
	"./baby-child-kid-svgrepo-com.svg": 510,
	"./beard-hipster-male-svgrepo-com.svg": 8296,
	"./boy-indian-kid-svgrepo-com.svg": 825,
	"./builder-helmet-worker-svgrepo-com.svg": 4382,
	"./child-girl-kid-svgrepo-com.svg": 5118,
	"./christmas-clous-santa-svgrepo-com.svg": 4301,
	"./fighter-luchador-man-svgrepo-com.svg": 3783,
	"./friday-halloween-jason-svgrepo-com.svg": 5981,
	"./indian-male-man-svgrepo-com.svg": 8300,
	"./indian-man-sikh-svgrepo-com.svg": 2844,
	"./male-man-old-svgrepo-com.svg": 3464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4303;